<header>
    <div class="container-fluid">
        <div class="d-flex">
            <div class="logo"><img src="assets/images/NSEICC.png" routerLink=""></div>
            <div class="signin">
                <h3><a (click)="signin()"><i class="fa fa-sign-in" aria-hidden="true"></i>&nbsp;Sign In</a></h3>
            </div>
        </div>
    </div>
    <div class="seperator">
        <div class="col-lg-1 seperator1"></div>
        <div class="col-lg-2 seperator2"></div>
        <div class="col-lg-4 seperator3"></div>
        <div class="col-lg-5 seperator4"></div>
    </div>
</header>
<div class="row justify-content-center mt-2">
    <div class="registerForm col-lg-11">
        <div class="row justify-content-center mb-2">
            <h1>REGISTER PARTICIPANT</h1>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>